/**
 * Languette de choix de la langue.
 * Le changement de langue reste une soumission de formulaire native :
 * il fonctionne meme si ce script ne se charge pas.
 */
class LanguageTab extends HTMLElement {
  connectedCallback() {
    this.handle = this.querySelector('[data-language-tab-toggle]');
    this.handle?.addEventListener('click', () => this.setOpen(this.dataset.open !== 'true'));

    this.onDocumentClick = (event) => {
      if (this.dataset.open === 'true' && !this.contains(event.target)) this.setOpen(false);
    };
    this.onKeydown = (event) => {
      if (event.key === 'Escape' && this.dataset.open === 'true') {
        this.setOpen(false);
        this.handle?.focus();
      }
    };

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  setOpen(open) {
    this.dataset.open = open ? 'true' : 'false';
    this.handle?.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
}

if (!customElements.get('language-tab')) {
  customElements.define('language-tab', LanguageTab);
}
